export default "__VITE_ASSET__GNHN4TUU__"